//reducer is where state goes
// action dispatch to reducer
//e.g. getItems dispatch to reducer
// send response (state) from server to reducer

import { MEETING_MINUTES_NOTIFICATION } from "../actions/types";

const initialState = {
  notification: "",
};

//will later get state from api

export default function (state = initialState, action) {
  switch (action.type) {
    case MEETING_MINUTES_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      };
    default:
      return state;
  }
}
